// extracted by mini-css-extract-plugin
module.exports = {"sliced":"BlogArticle-module--sliced--2awr1","blogImage":"BlogArticle-module--blogImage--3DvG-","blogIntro":"BlogArticle-module--blogIntro--wPS26"};